<template>
  <v-card class="change-password-page d-flex align-center justify-center rounded-0 bg" width="100vw" min-height="100vh">
    <div class="logo">
      <img src="../../assets/epicor.png" alt="Epicor" />
    </div>

    <v-card class="change-password-card pa-10 d-flex flex-column align-center rounded-xl" width="420px">
      <h3 class="mb-6">Change Password</h3>

      <div class="width-100">
        <v-text-field v-model="form.oldPassword" :append-icon="showOldPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showOldPassword ? 'text' : 'password'" label="Old Password" color="#333333" :rules="[rules.required]"
          class="input-group--focused" @click:append="showOldPassword = !showOldPassword" />

        <v-text-field v-model="form.newPassword" :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showNewPassword ? 'text' : 'password'" label="New Password" color="#333333"
          :rules="[rules.required, rules.passwordMin]" class="input-group--focused"
          @click:append="showNewPassword = !showNewPassword" />

        <v-text-field v-model="form.confirmPassword" :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showConfirmPassword ? 'text' : 'password'" label="Confirm Password" color="#333333"
          :rules="[rules.required, rules.confirmPassword]" class="input-group--focused"
          @click:append="showConfirmPassword = !showConfirmPassword" @keyup.enter="handleSubmit" />
      </div>

      <div v-if="errorMessage" class="width-100 error-text mb-3">
        {{ errorMessage }}
      </div>

      <div v-if="successMessage" class="width-100 success-text mb-3">
        {{ successMessage }}
      </div>

      <v-btn elevation="2" min-width="150px" class="mb-3 width-100" :loading="loading" :disabled="loading"
        @click="handleSubmit">
        Update Password
      </v-btn>

      <a class="back-link" @click="goToLogin">Back to Login</a>
    </v-card>

    <div class="d-flex align-center justify-center direction-column footer-wrap">
      <h4 class="d-flex footer-text">
        &copy; 2023 Developed by Data V Tech Solutions Company Limited
      </h4>
      <a class="d-flex footer-link" href="https://www.datavtech.com">
        www.datavtech.com
      </a>
    </div>
  </v-card>
</template>

<script>
import DecodeJWT from "../DecodeJWT";

export default {
  name: "ForgotPassword",
  data() {
    return {
      loading: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      errorMessage: "",
      successMessage: "",
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        required: (value) => !!value || "This field is required",
        passwordMin: (value) =>
          (value && value.length >= 6) ||
          "Password must be at least 6 characters",
        confirmPassword: (value) =>
          value === this.form.newPassword || "Confirm password does not match",
      };
    },
  },
  mounted() {
    this.ensureValidSession();
  },
  methods: {
    ensureValidSession() {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.$router.push("/login");
          return;
        }

        const info = DecodeJWT(token);
        const isExpired = !info?.exp || info.exp <= Date.now() / 1000;

        if (isExpired) {
          localStorage.removeItem("token");
          this.$router.push("/login");
          return;
        }
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("token");
        this.$router.push("/login");
      }
    },

    validateForm() {
      this.errorMessage = "";
      this.successMessage = "";

      if (!this.form.oldPassword) {
        this.errorMessage = "Please enter old password.";
        return false;
      }

      if (!this.form.newPassword) {
        this.errorMessage = "Please enter new password.";
        return false;
      }

      if (this.form.newPassword.length < 6) {
        this.errorMessage = "New password must be at least 6 characters.";
        return false;
      }

      if (!this.form.confirmPassword) {
        this.errorMessage = "Please enter confirm password.";
        return false;
      }

      if (this.form.newPassword !== this.form.confirmPassword) {
        this.errorMessage = "Confirm password does not match.";
        return false;
      }

      if (this.form.oldPassword === this.form.newPassword) {
        this.errorMessage = "New password must be different from old password.";
        return false;
      }

      return true;
    },

    async handleSubmit() {
      if (!this.validateForm()) return;

      this.loading = true;
      this.errorMessage = "";
      this.successMessage = "";

      try {
        await this.$store.dispatch("User/changePassword", {
          oldPassword: this.form.oldPassword,
          newPassword: this.form.newPassword,
        });

        this.successMessage = "Password updated successfully.";

        setTimeout(() => {
          this.$router.push("/home");
        }, 800);
      } catch (error) {
        console.error("Change password error:", error);
        this.errorMessage =
          error?.response?.data?.message ||
          error?.message ||
          "Unable to change password.";
      } finally {
        this.loading = false;
      }
    },

    goToLogin() {
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped lang="scss">
.width-100 {
  width: 100%;
}

.bg {
  flex-direction: column;
  background-color: #006780;
  background-size: cover;
}

.change-password-page {
  position: relative;
  padding: 24px;
}

.change-password-card {
  background-color: #ffffff;
  height: auto;
}

.logo {
  margin-bottom: 24px;
}

.logo img {
  max-width: 180px;
  height: auto;
}

.direction-column {
  flex-direction: column;
}

.footer-wrap {
  margin-top: 40px;
}

.footer-text,
.footer-link {
  color: white;
}

.footer-link {
  text-decoration: underline;
}

.error-text {
  color: red;
}

.success-text {
  color: green;
}

.back-link {
  text-decoration: underline;
  cursor: pointer;
  color: black !important;
}

a:hover {
  font-weight: bolder;
}
</style>